export function getCurrencySymbol(locale: string, currency: string): string {
	return (
		new Intl.NumberFormat(locale, { style: 'currency', currency })
			.formatToParts(99) // number doesn't matter here
			.find(({ type }) => type === 'currency')?.value || '$'
	);
}
